import * as qplsService from '../../../services/Qpls/qplsService'
import {gridsNames} from '../../../enums/gridsNames';
import * as gridActionsHelper from 'infrastructure/js/components/Grid/Utils/gridActionsHelper';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';

const gridActions = gridActionsHelper.getGridActions(gridsNames.ADMINISTRATION_MAT_SETTINGS_QPLS_PENDING_REQUESTS, _fetchDataAction, _convertToRowData);

function _fetchDataAction(query) {
  return function(dispatch, getState) {
    return qplsService.fetchQplsPendingRequests(query);
  }
}

function _convertToRowData(rows, serverTimeSeconds) {
  let items = rows.map((row) => {
    row.m_Time = DateTimeHelper.FormatDateObjectToRelativeTime(row.requestTimestamp, serverTimeSeconds);
    return row;
  });

  return items;
}

export let actionTypes = gridActions.actionTypes, api = gridActions.apiActions, jsxActions = gridActions.jsxActions;
